import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'
// 证件类型

export default new EnumItem({
  '1': { value: 1, text: i18n.gettext('新版') },
  '2': { value: 2, text: i18n.gettext('老版无Curp') },
  '3': { value: 3, text: i18n.gettext('老版有Curp') }
})
